export const selectWithSearch = {
  placeholder: 'Select option...',
  searchPlaceholder: 'Search...',
  emptyMessage: 'No option found.',
  moreItems: 'more',
  selectedCount: 'selected',
} as const
